import {useEffect, useState} from "react";
import {extractMediaMeta} from "./dmsSecurity";
import {dateFormatter} from "../utility";
import {clientLog} from "../clientLog";

/**
 * Hook for fetching metadata for a given DMS ID.
 *
 * @param {object} [options] Options object.
 * @param {string} [options.collectionId] The collection ID to fetch metadata from.
 * @param {string} [options.dmsId] The DMS ID to fetch metadata for.
 * @param {boolean} [options.ready] Whether the hook is ready to fetch metadata.
 * @param {object} [options.model] Model object, used to determine the file type of the
 *   object and skip fetching metadata for .glb files.
 *
 * @returns {object} The metadata of the object.
 */
export const useDmsFileMetadata = ({collectionId, dmsId, model = null, ready = true}) => {
    const [metadata, setMetadata] = useState({});

    useEffect(() => {
        let skip = false;
        if (model) {
            // Skip fetching metadata for .glb files.
            const f = model.content.mediae[0].reference.title;
            const fileType = f.substring(f.lastIndexOf(".") + 1);
            skip = fileType.toLowerCase() === 'glb';
        }

        if (collectionId && dmsId && ready && !skip) {
            (async () => {
                try {
                    const metadata = await extractMediaMeta(collectionId, dmsId);
                    const parsed = dateFormatter(metadata[0]);
                    setMetadata(parsed);
                } catch (e) {
                    clientLog('error', e, 'useDmsFileMetadata');
                }
            })();
        }
    }, [collectionId, dmsId, ready, model]);

    return metadata
}
